export const ROLE_USER = "USER"
export const ROLE_TRAINER = "TRAINER"
export const ROLE_VIP = "VIP"
export const ROLE_ADMIN = "ADMIN"

export const LAWFUL_SUBSCRIPTION_ROLES = [ROLE_TRAINER, ROLE_VIP, ROLE_ADMIN]
export const LAWFUL_HUMAN_3D_ROLES = [ROLE_VIP, ROLE_ADMIN]
